export default __webpack_public_path__ + "static/logo-e31ae38c58c3accba502b04b1c046de4.svg";